// Copyright (c) 2022 by Move Closer

import { IRelatedService, ModuleContentResolver, ProductData } from '../../contexts'

import { NavigationCTABoxModuleContent, NavigationCTABoxModuleContentInput } from './NavigationCTABox.contracts'
import { logger } from '../../support'

/**
 * @author Wojciech Falkowski <wojciech.falkowski@movecloser.pl>
 */
export const resolveNavigationCTABoxModuleContent: ModuleContentResolver<NavigationCTABoxModuleContentInput, NavigationCTABoxModuleContent> =
  async (
    input: NavigationCTABoxModuleContentInput,
    relatedService: IRelatedService
  ): Promise<NavigationCTABoxModuleContent> => {
    let product: ProductData | null = null

    try {
      product = await relatedService.resolve<ProductData>(input.product)
    } catch (e) {
      logger(e, 'warn')
    }

    return {
      product
    }
  }
